import { IDB_rowRead, IDB_rowsDelete, IDB_rowsReadAll, IDB_rowsWrite } from './IDB.queries'
import { IDB_globalDb } from './IDB'
import type { Type_ILocationFocusList } from '../Type/Type.hive'

export function IDB_locationFocusListRead(locationFocusListId: number) {
    return IDB_rowRead<Type_ILocationFocusList>(IDB_globalDb, 'locationFocusLists', locationFocusListId)
}

export function IDB_locationFocusListsDelete(locationFocusListId: number[]) {
    return IDB_rowsDelete(IDB_globalDb, 'locationFocusLists', locationFocusListId)
}

export function IDB_locationFocusListsReadAll() {
    return IDB_rowsReadAll<Type_ILocationFocusList>(IDB_globalDb, 'locationFocusLists')
}

export function IDB_locationFocusListsWrite(locationFocusLists: Type_ILocationFocusList[]) {
    return IDB_rowsWrite(IDB_globalDb, 'locationFocusLists', locationFocusLists)
}
